import { useState } from "react";
import QuantitiesVarianceReportDetails from "./QuantitiesVarianceReportDetails";
import FilterData from "../FilterData";

const QuantitiesVarianceReport = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [params,setParams] = useState()
  const handleClick = (): void => {
      setOpen(true);
  };  
  const handleFilterChange = (): void => {
      setOpen(false);
  };  
  const handleParamsChange = (values:any): void => {
    setParams(values)
  }
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Projected Quantities vs Requested Quantities Variance Report
      </h1>
      <FilterData handleClick={handleClick} handleFilterChange={handleFilterChange} handleParamsChange={handleParamsChange}/>
      {open && 
        <QuantitiesVarianceReportDetails params={params}/>
      }      
    </div>    
  );
};

export default QuantitiesVarianceReport;
